import {cn} from '../../lib/utils';
import {Skeleton} from '../shadcn/skeleton';

export interface FieldSkeletonProps {
  /** Positioning classes — each field type overlays this at its own value's location. */
  className?: string;
}

/**
 * Pulsing placeholder overlaid where a field's value/placeholder renders while AI is filling it in.
 * `z-10` because it must paint above the field's own control — a plain absolute sibling loses to a
 * positioned one (e.g. the combobox input shell), which would hide the skeleton behind it.
 */
export function FieldSkeleton({className}: FieldSkeletonProps) {
  return (
    <Skeleton
      aria-hidden
      style={{animationDuration: '1.6s'}}
      className={cn('pointer-events-none absolute z-10 h-2 w-40 rounded-full', className)}
    />
  );
}
